import { Typography, styled } from "@mui/material";
import { detailRowName } from "../classes.js";
const Label = styled(Typography, {
  name: detailRowName,
  slot: "Label",
  overridesResolver: (_props, styles) => styles.label
})(({ theme }) => ({
  color: (theme.vars ?? theme).palette.text.secondary
}));
export {
  Label
};
//# sourceMappingURL=Label.js.map
